import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/trends/page.tsx");
